import apiClient from './client'
import API from '@/api/API'
import { SettingsResponse } from '@/lib/types/api'

export const settingsApi = {
  get: async () => {
    const response = await apiClient.get<SettingsResponse>(API.settings.base)
    return response.data
  },

  update: async (data: Partial<SettingsResponse>) => {
    const response = await apiClient.put<SettingsResponse>(API.settings.base, data)
    return response.data
  }
}
